import React from 'react';
import { Pressable } from 'react-native';
import { createStyleSheet, useStyles } from 'react-native-unistyles';

import { Text } from '@/ui';
import { Icon } from '@/ui/icon';
import { Cancel } from '@/ui/icons/cancel';
import { ChevronLeft } from '@/ui/icons/chevron-left';

export enum NavigationButtonTypes {
  cancel = 'cancel',
  back = 'back',
  back_with_text = 'back_with_text',
}

interface NavigationButtonProps {
  type: NavigationButtonTypes;
  onPress: () => void;
  style?: any;
}

export const NavigationButton = ({
  type,
  onPress,
  style,
}: NavigationButtonProps) => {
  const { styles, theme } = useStyles(stylesheet);

  if (type === 'cancel') {
    return (
      <Pressable
        hitSlop={8}
        onPress={onPress}
        style={({ pressed }) => [
          styles.cancelButton,
          style,
          { opacity: pressed ? 0.5 : 1 },
        ]}
      >
        <Icon
          type="naked"
          icon={<Cancel />}
          stroke={theme.colors.navigationButton.color}
          fillColor={theme.colors.navigationButton.color}
          width={12}
          height={12}
        />
      </Pressable>
    );
  }

  if (type === 'back') {
    return (
      <Pressable
        hitSlop={8}
        onPress={onPress}
        style={({ pressed }) => [
          styles.backButton,
          style,
          { opacity: pressed ? 0.5 : 1 },
        ]}
      >
        <Icon
          type="naked"
          icon={<ChevronLeft />}
          stroke={theme.colors.navigationButton.color}
          fillColor={theme.colors.navigationButton.color}
          width={12}
          height={12}
        />
      </Pressable>
    );
  }

  if (type === 'back_with_text') {
    return (
      <Pressable
        hitSlop={8}
        onPress={onPress}
        style={({ pressed }) => [
          styles.cancelButton(type),
          style,
          { opacity: pressed ? 0.5 : 1 },
        ]}
      >
        <Icon
          type="naked"
          icon={<ChevronLeft />}
          stroke={theme.colors.navigationButton.color}
          fillColor={theme.colors.navigationButton.color}
          width={12}
          height={12}
        />
        <Text tx="navigationButton.back" />
      </Pressable>
    );
  }

  return null;
};

const stylesheet = createStyleSheet((theme) => ({
  backButton: {
    width: 40,
    height: 40,
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 100,
    borderWidth: 1,
    borderColor: theme.colors.background_3,
    backgroundColor: theme.colors.background_2,
  },
  cancelButton: (type: NavigationButtonProps['type']) => ({
    width: type === 'back_with_text' ? 80 : 40,
    height: 40,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 4,
    borderRadius: 100,
    borderColor: theme.colors.navigationButton.border,
    backgroundColor: theme.colors.navigationButton.fill,
  }),
}));
